import ConfirmExternalLink from "@/components/ConfirmExternalLink";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ChevronDown, Scale } from "lucide-react";

const HeroSection = () => {
  const scrollToNextSection = () => {
    const faqSection = document.getElementById("faq");
    if (faqSection) {
      faqSection.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="relative pt-0 pb-12 md:pt-2 md:pb-20 lg:pt-4 lg:pb-28">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto space-y-8">
          <Badge
            variant="secondary"
            className="text-xs font-medium px-4 py-1.5 animate-fade-in opacity-0 dark:bg-muted dark:text-muted-foreground flex items-center gap-2"
            style={{ animationDelay: "0.1s", animationFillMode: "forwards" }}
          >
            <span className="w-2 h-2 rounded-full animate-[pulse-colors_2s_ease-in-out_infinite]" />
            PORTAL NÃO OFICIAL
          </Badge>

          <h1
            className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold leading-[1.1] tracking-tight animate-fade-in opacity-0"
            style={{ animationDelay: "0.2s", animationFillMode: "forwards" }}
          >
            Cadastro Imobiliário Brasileiro
          </h1>

          <p
            className="text-muted-foreground text-lg md:text-xl lg:text-2xl leading-relaxed max-w-2xl animate-fade-in opacity-0"
            style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}
          >
            O portal de referência sobre a nova lei que moderniza o registro de
            imóveis no Brasil. Informação, capacitação e ferramentas para
            profissionais e cidadãos.
          </p>

          <div
            className="flex flex-col sm:flex-row items-center gap-4 pt-4 w-full sm:w-auto animate-fade-in opacity-0"
            style={{ animationDelay: "0.6s", animationFillMode: "forwards" }}
          >
            <ConfirmExternalLink
              href="https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp214.htm"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-8 h-14 rounded-full border-2 border-border hover:border-primary hover:bg-muted/60 transition-all hover:scale-105 text-md font-medium"
            >
              <Scale className="w-4 h-4" />
              Acessar Lei
            </ConfirmExternalLink>
            <Button
              onClick={scrollToNextSection}
              className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full w-full sm:w-auto px-10 h-14 text-md font-medium transition-all hover:scale-105"
            >
              Saiba Mais
            </Button>
          </div>

          <button
            onClick={scrollToNextSection}
            className="mt-12 text-muted-foreground hover:text-foreground transition-colors animate-fade-in opacity-0"
            style={{ animationDelay: "0.8s", animationFillMode: "forwards" }}
            aria-label="Rolar para baixo"
          >
            <ChevronDown
              className="w-10 h-10 animate-bounce"
              style={{ animationDelay: "1s" }}
            />
          </button>
        </div>
      </div>
    </section>
  );
};
export default HeroSection;
